"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var S = _interopRequireWildcard(require("../../Form/DateInput/styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var dateBoundaries = function dateBoundaries(date) {
  return {
    start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
    end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
  };
};

var DateRangeFilter = function DateRangeFilter(_ref) {
  var label = _ref.label,
      column = _ref.column,
      onApplyFilters = _ref.onApplyFilters,
      gotoPage = _ref.gotoPage,
      state = _ref.state,
      _ref$selectedFilters = _ref.selectedFilters,
      selectedFilters = _ref$selectedFilters === void 0 ? [] : _ref$selectedFilters;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var path = window.location.pathname;
  var claims = window.localStorage.getItem('claims');
  var user = claims ? JSON.parse(claims)['id'] : '';
  (0, _react.useEffect)(function () {
    var storedFilters = JSON.parse(window.localStorage.getItem("".concat(user, "_filterValues").concat(path)));

    if (storedFilters && storedFilters[column.id]) {
      column.setFilter({
        before: storedFilters[column.id]['before'],
        after: storedFilters[column.id]['after']
      });
      setStartDate(new Date(storedFilters[column.id]['after']));
      setEndDate(new Date(storedFilters[column.id]['before']));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (startDate && endDate) {
      column.setFilter({
        before: endDate.toISOString(),
        after: startDate.toISOString()
      });
    }
  }, [startDate, endDate]);
  (0, _react.useEffect)(function () {
    // Clear filters on reset
    if (Object.keys(state[0].filters).length === 0) {
      setStartDate(null);
      setEndDate(null);
    }
  }, [state[0].filters]);

  function handleBlur() {
    if (startDate && endDate) {
      onApplyFilters();
      gotoPage(0);
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedFilters[column.id] && /*#__PURE__*/_react["default"].createElement(S.DatePickerInput, {
    className: "form-group mb-2 mb-lg-0 mr-lg-2"
  }, /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement(S.DatePickerContainer, {
    className: "form-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-xl-6 mb-2 mb-xl-0"
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    className: "datepicker__start-date form-control",
    placeholderText: "Start Date",
    dateFormat: "dd/MM/yyyy",
    selected: startDate,
    onChange: function onChange(date) {
      var start = new Date(date).getTime();
      var end = new Date(endDate).getTime();
      setStartDate(dateBoundaries(date).start);

      if (!endDate || start > end) {
        setEndDate(dateBoundaries(date).end);
      }
    },
    onBlur: handleBlur,
    selectsStart: true,
    startDate: startDate,
    endDate: endDate
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-xl-6"
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    className: "datepicker__end-date form-control",
    placeholderText: "End Date",
    dateFormat: "dd/MM/yyyy",
    selected: endDate,
    onChange: function onChange(date) {
      return setEndDate(dateBoundaries(date).end);
    },
    onBlur: handleBlur,
    selectsEnd: true,
    startDate: startDate,
    endDate: endDate,
    minDate: startDate
  })))));
};

DateRangeFilter.propTypes = {
  label: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  column: _propTypes["default"].shape({
    filterValue: _propTypes["default"].object,
    setFilter: _propTypes["default"].func.isRequired
  }),
  onApplyFilters: _propTypes["default"].func.isRequired
};
var _default = DateRangeFilter;
exports["default"] = _default;